import { Component, Input } from '@angular/core';

@Component({
  selector: 'cigna-omni-comm-channel-subheader',
  templateUrl: './subheader.component.html',
  styleUrls: ['./subheader.component.scss'],
})
export class SubheaderComponent {
  @Input()
  public omniQaTag: string | null;
}
